import React, { Component } from "react";
// import { connect } from 'react-redux';
// import { withRouter } from 'react-router-dom';

import {
  Dialog,
  // CircularProgress,
  DialogContent,
  DialogContentText,
  Checkbox, Typography
  // Typography,
} from "@material-ui/core";

// import Alert from '../../common/components/Alert';
// import SocialLoginButtons from './SocialLoginButtons';
// import * as authActions from '../actions';

// import * as routes from '../../config/routes';
import classes from "../../css/getCSS";
import Grid from "@material-ui/core/Grid";
// import { GoogleLogin } from "react-google-login";
// import * as constants from "../../config/constants";
import Button from "@material-ui/core/Button";
// import Icon from "@material-ui/core/Icon";
import axios from "../../config/axios";
import Axios from "axios";
import { formatRoute } from "react-router-named-routes";
import * as routes from "../../config/routes";
import { Link } from "react-router-dom";
import MainLayout from "../../common/components/MainLayout";
import InputField from "../../common/components/inputField";
import TextField from "@material-ui/core/TextField";
import RefreshIcon from '@material-ui/icons/Refresh';
import { string } from "prop-types";




class DisclaimersMenu extends Component {
  state = {
    text: "",
    captchaCode: Math.floor(Math.random()*9000) + 1000,
    checkCaptchaCode:null,
    checkBoxCheck:false,
    error:'',
    dontAgreeButtonClick:false
  };

  componentDidMount() {
    console.log(classes);
    axios.get("/disclaimers/disclaimer-permission")
      .then((response) => {
        this.setState({
          text: (<div className={classes.settingsText} dangerouslySetInnerHTML={{ __html: response.data.permission_text }} />)
        });
      }).catch((error) => {
      console.log(error);
    });
  }

  render() {
    let inputClasses = [classes.textField];

    const acceptButtonClick = (e) => {
      if (this.state.captchaCode === this.state.checkCaptchaCode && this.state.checkBoxCheck) {
        Axios.get("https://ipapi.co/json/")
          .then((res) => {
            const data = res.data;
            const apiData = {
              "ip": data.ip,
              "city": data.city,
              "country": data.country_name,
              "region": data.region,
              "latitude": data.latitude,
              "longitude": data.longitude
            };
            axios.post("/disclaimers/complete-disclaimers", apiData)
              .then((response) => {
                this.props.history.push(routes.HOME)
              });
          });
      } else {
        let errorMessage = '';
        if (!this.state.checkBoxCheck) {
          errorMessage = errorMessage + "Please accept terms and conditions, privacy policy and disclaimer. ";
        }
        if (this.state.captchaCode !== this.state.checkCaptchaCode) {
          errorMessage = errorMessage + "Please enter valid captcha code"
        }
        this.setState({ error: errorMessage })
      }
    };

    const dontAcceptButtonClick = () => {
      this.setState({
        'text': "Please accept terms and conditions and privacy policy to continue using site.",
        'dontAgreeButtonClick': true,
        'error':''
      })
    }

    const reloadPage = () => {
      window.location.reload();
    }

    let buttons = (
      <div align="center">
        <React.Fragment>
          <Grid container>
            <Grid item md={12} xs={12} sm={12}>
              <Button variant="contained" color="default"
                      style={{ backgroundColor: "#db3236", color: "#fff", marginRight: "10px" }}
                      onClick={(e) => acceptButtonClick(e)}>
                I Agree
              </Button>
              <Button variant="contained" color="default" style={{ backgroundColor: "rgba(0,0,0,0.7)", color: "#fff" }}
                      onClick={dontAcceptButtonClick}
                // onClick={(e) => {window.open(,'_self').close()}}
              >
                I Disagree
              </Button>
            </Grid>
          </Grid>
        </React.Fragment>
      </div>
    );

    if (this.state.dontAgreeButtonClick) {
      buttons = (
        <div align="center">
          <React.Fragment>
            <Grid container>
              <Grid item md={12} xs={12} sm={12}>
                <Button variant="contained" color="default" style={{ backgroundColor: "#db3236", color: "#fff" }}
                        onClick={reloadPage}
                >
                  Reload
                </Button>
              </Grid>
            </Grid>
          </React.Fragment>
        </div>
      )
    }

    const changeCheckBoxValue = () => {
      console.log('this.state.checkBoxCheck', this.state.checkBoxCheck);
      this.state.checkBoxCheck = this.state.checkBoxCheck ? false : true
      console.log('this.state.checkBoxCheck', this.state.checkBoxCheck);
    }

    let checkbox = (
      <div align="center">
        <React.Fragment>
          <Grid container>
            <Grid item md={12} xs={12} sm={12}>
              <Checkbox defaultChecked={this.state.checkBoxCheck} size="small" color="default"
                        onChange={changeCheckBoxValue} className={classes.disclaimerCheckbox} />
              &nbsp;I accept all&nbsp;
              <Link to={formatRoute(routes.TERMS_AND_CONDITION, { page: 'termsAndConditions' })} target="_blank">
                terms and conditions
              </Link>
              &nbsp;and&nbsp;
              <Link to={formatRoute(routes.TERMS_AND_CONDITION, { page: 'privacyPolicy' })}>
                privacy policy.
              </Link>
            </Grid>
          </Grid>
          <br/>
        </React.Fragment>
      </div>
    );

    if (this.state.dontAgreeButtonClick) {
      checkbox = null
    }

    const setCaptchaValue = (event) => {
      event.preventDefault()
      this.state.checkCaptchaCode = Number(event.target.value)
    }

    let error = (
      <div align="center">
        <React.Fragment>
          <Grid container>
            <Grid item md={12} xs={12} sm={12}>
              <Typography style={{ color: "red" }}>{this.state.error}</Typography>
            </Grid>
          </Grid>
          <br/>
        </React.Fragment>
      </div>
    )

    const changeCaptcha = () => {
      this.setState({ 'captchaCode':Math.floor(Math.random() * 9000) + 1000 })
    }

    let captchaCode = (
      <React.Fragment>
        <Grid container style={{ justifyContent: 'center' }}>
          <Grid item md={4} xs={12} sm={12}>
            <Grid container spacing={24}>
              <Grid item md={6} xs={12} sm={6}>
                <Typography>Captcha Code</Typography>
                <div className={classes.captcha}>
                  <span>{this.state.captchaCode.toString()[0]}</span>
                  <span>{this.state.captchaCode.toString()[1]}</span>
                  <span>{this.state.captchaCode.toString()[2]}</span>
                  <span>{this.state.captchaCode.toString()[3]}</span>
                  <RefreshIcon onClick={changeCaptcha}></RefreshIcon>
                </div>
              </Grid>
              <Grid item md={6} xs={12} sm={6}>
                <Typography>Enter Captcha Code</Typography>
                <TextField
                  className={inputClasses.join(' ')}
                  onChange={(event) => setCaptchaValue(event)}
                  size={"small"}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <br/>
      </React.Fragment>
    )

    if (this.state.dontAgreeButtonClick){
      captchaCode = null
    }

    return (
      <MainLayout notLayoutView={true}>
        <Grid container style={{ justifyContent: 'center' }}>
          <Grid item md={8} sm={10} xs={12}>
            <Dialog
              maxWidth="lg"
              fullWidth
              open={true}
              aria-labelledby="login-dialog-title"
              aria-describedby="login-dialog-description"
              classes={{
                paper: classes.dialogCard
              }}
            >
              <DialogContent>
                <DialogContentText style={{ textAlign: "center", fontSize: "1.2rem", fontWeight: "bold" }} justify="center">
                  Disclaimer Permission
                </DialogContentText>
                <br />
                <DialogContentText style={{ textAlign: "center", fontWeight: "bold" }} justify="center">
                  {this.state.text}
                </DialogContentText>
                <br/>
                {checkbox}
                {captchaCode}
                {error}
                {buttons}
              </DialogContent>
            </Dialog>
          </Grid>
        </Grid>
      </MainLayout>
    );
  }
}

export default DisclaimersMenu;



// WEBPACK FOOTER //
// ./src/auth/components/DisclaimersMenu.js